// extracted by mini-css-extract-plugin
module.exports = {"dashboardFilter":"dashboardFilter__PA+ri"};